import { render, staticRenderFns } from "./ManageProducts.vue?vue&type=template&id=0b8346b2&"
import script from "./ManageProducts.vue?vue&type=script&lang=js&"
export * from "./ManageProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports